import React from 'react';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Theme } from '@mui/material/styles';
import { Incident, TEMPERATURE_THRESHOLDS } from '../../types';
import { deviceNameCellStyles } from './styles';

interface DeviceNameCellProps {
  params: GridRenderCellParams<Incident>;
  theme: Theme;
}

const DeviceNameCell: React.FC<DeviceNameCellProps> = ({ params, theme }) => {
  const isIncident = params.row.maxCellT > TEMPERATURE_THRESHOLDS.INCIDENT;

  return (
    <Typography sx={deviceNameCellStyles(theme, isIncident)}>
      {params.value}
    </Typography>
  );
};

DeviceNameCell.displayName = 'DeviceNameCell';

export default DeviceNameCell;
